import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex px-5 md:px-40 mb-8 p-3" }

import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import apiUseCase from '@/usecase/apiUseCase'
import moment from 'moment'
import HorizontalStepper from '@/views/components/stepper/Horizontal.vue'
import FormInformation from './form/Information.vue'
import FormPreview from './form/Preview.vue'
import FormSelectBus from './form/SelectBusAirport.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form2',
  setup(__props) {

const module = 'globalSetting'

const store = useStore()
const route = useRoute()

const steps = ref([{
  key: 1,
  titleCircle: '1',
  title: 'Informasi Trayek',
  iconDone: ''
},
{
  key: 2,
  titleCircle: '2',
  title: 'Pilih Bus',
  iconDone: ''
},
{
  key: 3,
  titleCircle: '3',
  title: 'Review',
  iconDone: ''
}])

// const selectedStep = ref(2)
const selectedStep = computed({
  get: () => store.state.trayek.formStep,
  set: (value) => {
    store.dispatch('setTrayekFormStep', value)
  }
})

const endpoint = '/management/v1/Trayek'
const isLoading = ref(true)
const maxPp = computed(() => store.getters[`${module}/maxPp`]?.Value)

const initForm1 = (data: any) => {
  const objMain = {
    Name: data.Name,
    Code: data.Code,
    Class: {
      Id: data.MsClassId,
      Name: data.MsClass.Name,
      Description: data.MsClass.Description,
      RefundAmount: data.MsClass.RefundAmount,
      label: data.MsClass.Name,
      value: data.MsClassId,
    },
    StartDate: data.StartDate,
    EndDate: data.EndDate,
    EstimatedFuelConsumptionLiters: data.EstimatedFuelConsumptionLiters,
    MaximumFuelConsumptionLiters: data.MaximumFuelConsumptionLiters,
    MinimumFuelConsumptionLiters: data.MinimumFuelConsumptionLiters,
    IsTol: data.IsTol,
    Rits: [] as any
  }

  if (data.TrayekRoute.length > 0) {
    data.TrayekRoute.forEach((d: any, i: any) => {
      const obj = {
        trayekRouteId: d.Id,
        rit: d.MsRoute ? {
          Id: d.MsRoute ? d.MsRoute.Id : null,
          Name: d.MsRoute.Name,
          Code: d.MsRoute.Code,
          label: d.MsRoute ? d.MsRoute.Name : null,
          value: d.MsRoute ? d.MsRoute.Id : null,
        } : null,
        expense: d.MsExpenses ? {
          Id: d.MsExpenses ? d.MsExpenses.Id : null,
          Details: d.MsExpenses ? d.MsExpenses.MsExpensesDetails : null,
          label: d.MsExpenses ? d.MsExpenses.Name : null,
          value: d.MsExpenses ? d.MsExpenses.Id : null
        } : null
      }

      objMain.Rits.push(obj)
    })
  }
  store.dispatch('setTrayekForm1', objMain)
  console.log('step1', objMain)
}

const initForm2 = (data: any) => {
  const arrData = [] as any
  console.log('data', data)
  if (data.TrayekDetails.length > 0) {
    data.TrayekDetails.forEach((d: any, i: any) => {
      const obj = {
        trayekDetailId: d.Id,
        nopol: d.MsVehicle ? {
          Id: d.MsVehicleId,
          Nopol: d.MsVehicle.Nopol,
          HullNumber: d.MsVehicle.HullNumber,
          Type: d.MsVehicle.Type,
          label: d.MsVehicle.Nopol,
          value: d.MsVehicleId
        } : null,
        pps: [] as any
      }

      // if (d.TrayekSubs.length > 0) {
      for (let index = 0; index < Number(d.TrayekSubs.length ?? 0); index++) {
        // const element = array[index];
        const arrival = d.TrayekSubs[index]?.ArrivalTime ? moment(d.TrayekSubs[index].ArrivalTime, 'HH:mm') : null
        const departure = d.TrayekSubs[index]?.DepartureTime ? moment(d.TrayekSubs[index].DepartureTime, 'HH:mm') : null
        const objSubs = {
          id: d.TrayekSubs[index] ? d.TrayekSubs[index].Id : null,
          // departure: departure ? departure : null,
          // arrival: arrival ? arrival : null
          departure: d.TrayekSubs[index]?.DepartureTime.slice(0, 5) ?? null,
          arrival: d.TrayekSubs[index]?.ArrivalTime.slice(0, 5) ?? null,
          isCrossDay: d.TrayekSubs[index]?.IsCrossDay ?? false,
          details: [] as any
        }
        const TrayekSubsDetailsTemp = d.TrayekSubs[index].TrayekSubsDetails
        console.log('groupSubsDetail', d.TrayekSubs[index].TrayekSubsDetails)
        const groupSubsDetailTemp = TrayekSubsDetailsTemp.reduce((group: any, item: any) => {
          const { RitOrder } = item
          group[RitOrder - 1] = group[RitOrder - 1] ?? []
          group[RitOrder - 1].push(item)
          return group
        }, {})
        const groupSubsDetail = Object.keys(groupSubsDetailTemp).map((key: any) => groupSubsDetailTemp[key])
        // const arr = []
        // const groupSubsDetail = TrayekSubsDetailsTemp.map((item: any) => {

        // })
        console.log('groupSubsDetail', groupSubsDetail[0])
        groupSubsDetail.forEach((item: any) => {
          const objSubsDetail = {
            detailTerminals: [] as any,
            departure: item[0].RitDepartureTime.slice(0, 5) ?? null,
            arrival: item[item.length - 1].RitArrivalTime.slice(0, 5) ?? null,
            isCrossDay: item.filter((e: any) => e.IsCrossDay).length > 0
          }
          item.forEach((itemTerminal: any, ix: any) => {
            const objTerminal = {
              id: itemTerminal.Id ?? null,
              terminalId: itemTerminal.MsRouteDetail?.MsStation?.Id,
              name: itemTerminal.MsRouteDetail?.MsStation?.Name,
              cityName: itemTerminal.MsRouteDetail?.MsStation?.CityName,
              departure: ix === item.length - 1 ? null : itemTerminal.RitDepartureTime.slice(0, 5) ?? null,
              arrival: ix === 0 ? null : itemTerminal.RitArrivalTime.slice(0, 5) ?? null,
              dayOffset: itemTerminal.DayOffset ?? 0,
              routeDetailId: itemTerminal.MsRouteDetailId,
            }
            objSubsDetail.detailTerminals.push(objTerminal)
          })
          objSubs.details.push(objSubsDetail)
        })
        // for (let indexDetail = 1; indexDetail <= groupSubsDetail.length; indexDetail++) {
        //   const objSubsDetail = {
        //     ...groupSubsDetail[indexDetail],
        //     departure: groupSubsDetail[indexDetail].RitDepartureTime,
        //     arrival: groupSubsDetail[indexDetail].RitArrivalTime
        //   }
        //   objSubs.details.push(objSubsDetail)
        // }

        // for (let indexDetail = 0; indexDetail < groupSubsDetail.length; indexDetail++) {
        //   const objSubsDetail = {
        //     id: d.TrayekSubs[index] ? d.TrayekSubs[index].TrayekSubsDetails[indexDetail]?.Id : null,
        //     departure: d.TrayekSubs[index]?.TrayekSubsDetails[indexDetail]?.RitDepartureTime.slice(0, 5) ?? null,
        //     arrival: d.TrayekSubs[index]?.TrayekSubsDetails[indexDetail]?.RitArrivalTime.slice(0, 5) ?? null,
        //     isCrossDay: d.TrayekSubs[index]?.TrayekSubsDetails[indexDetail]?.IsCrossDay ?? false,
        //   }
        //   objSubs.details.push(objSubsDetail)
        // }
        obj.pps.push(objSubs)
      }
      // }
      arrData.push(obj)
    })
    console.log('step2', arrData)
  }
  store.dispatch('setTrayekForm2', arrData)
}

const getDataDetail = async () => {
  if (route.params.id) {
    await apiUseCase.get(`${endpoint}/${route.params.id}`)
      .then(({ result, error }) => {
        if (!error) {
          console.log('resultXXX', result)
          initForm1(result)
          initForm2(result)
          console.log('state', store.state.trayek.form)
        }
      })
  }
  isLoading.value = false
}

onMounted(() => {
  selectedStep.value = 1
  store.dispatch('flushTrayekForm1')
  store.dispatch('setTrayekForm2', [])
  getDataDetail()
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(HorizontalStepper, {
            items: steps.value,
            value: _unref(selectedStep)
          }, null, 8, ["items", "value"])
        ]),
        (_unref(selectedStep) === 1)
          ? (_openBlock(), _createBlock(FormInformation, { key: 0 }))
          : (_unref(selectedStep) === 2)
            ? (_openBlock(), _createBlock(FormSelectBus, { key: 1 }))
            : (_unref(selectedStep) === 3)
              ? (_openBlock(), _createBlock(FormPreview, { key: 2 }))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})